import { login, getUser, getMenu } from "@/api/tokenAuth.js";
import { getToken, setToken, removeToken } from "@/utils/auth";
// import { GetUnReadCount } from "@/api/Notification";
import { Message } from "element-ui";

const state = {
  userInfo: null, // 用户信息
  companyInfo: null,
  personId: null,
  menuList: [],
  tempMenu: [
    {
      name: "UserManage",
      dispalyName: "用户管理",
      icon: "UserManage",
      route: "/UserManage",
    },
    {
      name: "Organization",
      dispalyName: "组织机构",
      icon: "Organization",
      showIcon: true,
      isShow: true,
      route: "/Organization",
    },
    {
      name: "RoleManage",
      dispalyName: "角色管理",
      icon: "RoleManage",
      route: "/RoleManage",
    },
  ],
  firstMenu: "/fieldWork",
  accessToken: getToken(), // token
  auth: [],
};

const mutations = {
  _setToken(state, accessToken) {
    state.accessToken = accessToken;
  },
  _setUser(state, data) {
    state.userInfo = data;
  },
  _setPersonId(state, data) {
    state.personId = data;
  },
  _setCompanyAndArea(state, data) {
    state.companyAndArea = data;
  },
  _setUserPhoto(state, data) {
    state.userInfo.UserPhoto = data;
  },
  _setLogo(state, data) {
    state.companyInfo.Logo = data;
  },
  _setCompanyName(state, data) {
    state.companyInfo.QYMC = data;
  },
  _setUpdateSize(state, value) {
    state.updateSize = value;
  },
  _setChangeNum(state, value) {
    state.changeNum = value;
  },
  _changeNum(state) {
    state.changeNum++;
  },
  UserOnline(state, data) {
    state.UserOnline = data;
  },
  PatrolReportCount(state, data) {
    state.PatrolReportCount = data;
  },
  _setAuth(state, data) {
    state.auth = data;
  },
  _setMenus(state, data) {
    state.menuList = data;
  },
};

const actions = {
  /**
   * @description 登录
   * @param {Object} userInfo 登录用户信息
   * @returns {boolean} true 登录成功  |  false 登录失败
   */
  login({ commit }, userInfo) {
    let formData = new URLSearchParams();
    for (const key in userInfo) {
      formData.append(key, userInfo[key]);
    }
    return login(formData, userInfo.tenants)
      .then(async (result) => {
        commit("_setToken", result.access_token);
        setToken(result.access_token);
        return Promise.resolve(result);
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  },
  /**
   * @description 获取用户信息
   */
  async getUserInfo({ commit, state }) {
    return await getUser().then(async (data) => {
      commit("_setUser", data.user);

      // getMenu().then((res) => {
      //   if (process.env.NODE_ENV != "development") {
      //     commit("_setMenus", [
      //       {
      //         dispalyName: "首页",
      //         route: "/Home",
      //         icon: "Home",
      //         showIcon: true,
      //         isShow: true,
      //         auth: "true",
      //       },
      //       ...res.webModules,
      //     ]);
      //   } else {
      //     state.menuList = state.tempMenu;
      //   }
      // });
      commit("_setAuth", data.auth.grantedPermissions);
      commit("_setUser", {
        ...data.user,
        boundaryId: data.boundaryId,
        organizationId: data.organizationId,
        boundaryName: data.boundaryName,
        organizationName: data.organizationName,
      });
      let menus = [];

      if (data.auth.grantedPermissions?.length) {
        data.auth.grantedPermissions.map((name) => {
          let menu = state.tempMenu.find((item) => item.dispalyName == name);
          if (menu) {
            menus.push(menu);
          }
        });
      }

      if (menus.length) {
        commit("_setMenus", menus);
        return { flag: true, ...menus[0] };
      }
      return { flag: false, msg: "抱歉！您暂无此系统权限！" };
    });
  },

  getUnReadCount({ state }) {
    // GetUnReadCount().then((res) => {
    //   state.Unread = res;
    // });
  },
  /**
   * @description 退出登录，清空登录状态
   */
  logout({ commit, state }) {
    removeToken();
    commit("_setToken", null);
    commit("_setUser", {});
    commit("_setPersonId", null);
    state.firstMenu = "/Home";
  },
};

const getters = {
  userInfo: (state) => {
    return state.userInfo;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
